/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CorrectPostalCodeRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectPostalCode.pb'
import {CorrectPostalCodeResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectPostalCode.pb'


export const correctPostalCode = (request: CorrectPostalCodeRequest, options?: CashRequestOptions) => post<CorrectPostalCodeRequest, CorrectPostalCodeResponse>("/2.0/cash/correct-postal-code", request, {...options, rejectOnError: true })